import { motion } from 'framer-motion';

const PageTransition = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      // Duración de 0.2s (casi instantáneo)
      transition={{ duration: 0.2, ease: "linear" }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;